import * as d3 from 'd3'
// import { legend } from "@d3/color-legend"

const DEFAULT_OPTS = {
  width: 400,
  height: 300,
  margin: { top: 20, right: 30, bottom: 30, left: 50 },
  colors: d3.schemeTableau10,
  fillOpacity: 1,
}

// const mergeDatasets = (datasets) => {
//   return datasets.reduce((a, b) => a.concat(b.data), [])
// }

class PieChart {
  constructor(svg, datasets = [], opts = {}) {
    const { width, height, margin, colors, fillOpacity } = Object.assign({}, DEFAULT_OPTS, opts)

    this.svgElement = svg
    this.svg = d3.select(svg)
    this.margin = margin
    this.colorsRange = colors
    this.fillOpacity = fillOpacity

    this.setSize(width, height)

    this.datasets = datasets

    this.build()
  }

  arc() {
    const { width, height } = this
    // console.log('arc', width, height)
    return d3.arc()
      .innerRadius(0)
      .outerRadius(Math.min(width, height) / 2 - 1)
  }

  arcLabel() {
    const { width, height } = this
    const radius = Math.min(width, height) / 2 * 0.8;
    return d3.arc().innerRadius(radius).outerRadius(radius);
  }

  pie() {
    return d3.pie()
      // .padAngle(0.005)
      .sort(null)
      .value(d => d.value)
  }

  colors() {
    // console.log(this, this.datasets.map(dataset => dataset.name))
    // d3.schemeCategory10

    // d3.scaleOrdinal()
    //   .domain(data.map(d => d.name))
    //   .range(d3.quantize(t => d3.interpolateSpectral(t * 0.8 + 0.1), data.length).reverse())
    return d3.scaleOrdinal(this.datasets.map(dataset => dataset.name), this.colorsRange)
  }

  build() {
    const { svg, width, height } = this
    // const color = colors
    // console.log(svg, arc, pie, colors)
    // console.log(arc())

    svg.attr("viewBox", [-width / 2, -height / 2, width, height])

    

    // const svg = d3.create("svg")
    //     .attr("viewBox", [-width / 2, -height / 2, width, height]);

    this.pieces = svg.append('g')
      .attr('class', 'pieces')

    this.labels = svg.append("g")
      .attr('class', 'labels')
      .attr("font-family", "sans-serif")
      .attr("font-size", 12)
      .attr("text-anchor", "middle")

    this.update(this.datasets)

    return svg.node();
  }

  setSize(width, height) {
    this.width = width
    this.height = height
    
    this.svgElement.setAttribute('width', width)
    this.svgElement.setAttribute('height', height)

    this.svg.attr("viewBox", [-width / 2, -height / 2, width, height])
  }

  resize(width, height) {
    this.setSize(width, height)
    this.update(this.datasets)
  }

  update(datasets) {
    const { arc, pie } = this
    console.log('chart.update', datasets)

    const t = this.svg.transition()
      .duration(750)

    // update the class's data prop
    this.datasets = datasets

    const arcs = pie()(this.datasets)

    // update the X axis:
    this.paths = this.pieces
      .selectAll("path")
      .data(arcs)
      .join("path")
        .attr("fill", d => this.colors()(d.data.name))
        .attr('fill-opacity', this.fillOpacity)
        .attr("d", arc.call(this))
      .append("title")
        .text(d => `${d.data.name}: ${d.data.value}`);


    this.labels
      .selectAll("text")
      .data(arcs)
      .join(
        enter => {
          return enter.append('text')
            .attr("transform", d => `translate(${arc.call(this).centroid(d)})`)
            .call(text => text.append("tspan")
              .attr('class', 'name')
              .attr("y", "-0.4em")
              .attr("font-weight", "bold")
              .text(d => d.data.name))
            .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.25).append("tspan")
              .attr('class', 'value')
              .attr("x", 0)
              .attr("y", "0.7em")
              .attr("fill-opacity", 0.7)
              .text(d => d.value))
        }, 
        update => {
          // console.log(update)
          update.select('.name')
            .text(d => d.data.name)

          update.select('.value')
            .text(d => d.value)
        }, 
        exit => exit
          .call(exit => exit.transition(t)
            .attr("y", 30)
            .remove())
      )
      // .join("text")
      //   .attr("transform", d => `translate(${arc.call(this).centroid(d)})`)
      //   .call(text => text.append("tspan")
      //       .attr("y", "-0.4em")
      //       .attr("font-weight", "bold")
      //       .text(d => d.data.name))
      //   .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.25).append("tspan")
      //       .attr("x", 0)
      //       .attr("y", "0.7em")
      //       .attr("fill-opacity", 0.7)
      //       .text(d => d.value))
  }

  


  // mousemove(bisector) {
  //   const { date, value } = bisector(d3.mouse(this.svg.node())[0])

  //   this.tooltip
  //     .attr("transform", `translate(${this.x()(date)},${this.y()(value)})`)
  //     .call(this.callout, `
  //       ${value.toLocaleString(undefined, {  })}
  //       ${date.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric" })}
  //     `)
  // }

  // callout(g, value) {
  //   if (!value) return g.style("display", "none")
  
  //   g
  //     .style("display", null)
  //     .style("pointer-events", "none")
  //     .style("font", "10px sans-serif")
  
  //   const path = g.selectAll("path")
  //     .data([null])
  //     .join("path")
  //       .attr("fill", "white")
  //       .attr("stroke", "black");
  
  //   const text = g.selectAll("text")
  //     .data([null])
  //     .join("text")
  //     .call(text => text
  //       .selectAll("tspan")
  //       .data((value + "").split(/\n/))
  //       .join("tspan")
  //         .attr("x", 0)
  //         .attr("y", (_, i) => `${i * 1.1}em`)
  //         .style("font-weight", (_, i) => i ? null : "bold")
  //         .text(d => d));
  
  //   const { y, width: w, height: h } = text.node().getBBox();
  
  //   text.attr("transform", `translate(${-w / 2},${15 - y})`);
  //   path.attr("d", `M${-w / 2 - 10},5H-5l5,-5l5,5H${w / 2 + 10}v${h + 20}h-${w + 20}z`);
  // }

  // bisect() {
  //   const bisect = d3.bisector(d => d.date).left;
  //   const data = this.datasets[0].data
  //   return mx => {
  //     const date = this.x().invert(mx);
  //     const index = bisect(data, date, 1);
  //     const a = data[index - 1];
  //     const b = data[index];
      
  //     if (b === undefined) return a
  //     return date - a.date > b.date - date ? b : a;
  //   };
  // }
}

export { PieChart }